module.exports = __webpack_public_path__ + "static/img/broker2.46613ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/broker2.png
// module id = AzvB
// module chunks = 0